/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Pricing_FreeInputs */

const en_platform_pricing_free = /** @type {(inputs: Platform_Pricing_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const pl_platform_pricing_free = /** @type {(inputs: Platform_Pricing_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezpłatnie`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Platform_Pricing_FreeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_pricing_free = /** @type {((inputs?: Platform_Pricing_FreeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Pricing_FreeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_pricing_free(inputs)
	return en_platform_pricing_free(inputs)
});